import { render, staticRenderFns } from "./indeferimento-resumo.vue?vue&type=template&id=d922bcd2&scoped=true"
import script from "./indeferimento-resumo.vue?vue&type=script&lang=js"
export * from "./indeferimento-resumo.vue?vue&type=script&lang=js"
import style0 from "./indeferimento-resumo.vue?vue&type=style&index=0&id=d922bcd2&prod&scoped=true&lang=css"
import style1 from "./indeferimento-resumo.vue?vue&type=style&index=1&id=d922bcd2&prod&scoped=true&lang=css"
import style2 from "./indeferimento-resumo.vue?vue&type=style&index=2&id=d922bcd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d922bcd2",
  null
  
)

export default component.exports